import React from 'react'
import styled from 'styled-components'
import Dropdown from 'core-system/Dropdown/Dropdown'

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 2rem;
  border-right: 1px solid ${(props) => props.theme.palette.grey.grey300};
`

const FilterLabel = styled.span`
  font-size: 0.875rem;
  color: ${(props) => props.theme.palette.text.secondary};
  margin-right: 0.75rem;
  white-space: nowrap;
`

interface WorksitesFilterProps {
  selectedWorksite: string | null
  onWorksiteChange: (worksiteId: string | null) => void
  dropdownItems: { id: string; text: string }[]
}

const WorksitesFilter = React.memo((props: WorksitesFilterProps) => {
  const { selectedWorksite, onWorksiteChange, dropdownItems } = props

  const handleWorksiteChange = (item: { id: string; text: string }) => {
    // If "All Employees" is selected (empty string), pass null
    const selectedId = item.id === '' ? null : item.id
    onWorksiteChange(selectedId)
  }

  const activeItemId = selectedWorksite || ''

  return (
    <FilterContainer>
      <FilterLabel>Worksite:</FilterLabel>
      <Dropdown
        variant='textual'
        items={dropdownItems}
        active={activeItemId}
        itemCallback={handleWorksiteChange}
        placeholder='Select worksite'
        width='400px'
      />
    </FilterContainer>
  )
})

WorksitesFilter.displayName = 'WorksitesFilter'

export default WorksitesFilter
